import { Layout } from "Components/Layout/Layout";
import { PartnersContainer } from "Containers/PartnersContainer/PartnersContainer";

import React from "react";

export const Partners = () => {
  return (
    <Layout>
      <PartnersContainer/>
    </Layout>
  );
};
